import { Navigate } from 'react-router-dom';
import { route } from '../../route/Index';
import { useAppSelector } from '../../store/hook';
import { selectUser } from '../../store/user/userSlice';
import { ERole } from '../enum';

interface IIsAdmin {}

const isAdmin = <T extends IIsAdmin>(WrappedComponent: React.ComponentType<T>) => {
    return (_props: T) => {
        const user = useAppSelector(selectUser);
        if (user.data?.role != ERole.Admin) {
            return <Navigate to={route.info} />;
        }
        return <WrappedComponent {..._props} />;
    };
};

export default isAdmin;
